<app-common-header></app-common-header>
<main role="main" class="maincnt congrats quest">
  <div class="getbannersect sectppad pb-2 mt-1">
    <div class="sectpad container section">
      <div class="col-12 text-center webview">
        <img src="assets/images/logo-charcoal.png" class="signimg signimgg" />
      </div>
      <div class="row">
        <div class="col-sm-6 float-left">
          <p class="text-center mt-4 mobileview">
            <img
              class="mbwidth"
              src="assets/images/commercial-congrats.svg"
              width="80%"
            />
          </p>
          <h1
            class="clrpurple font-weight-bold-calibre text-left font50 mt-4 conmsg"
          >
            Submission Received
          </h1>
          <p class="text-left mt-4 webview">
            <img
              class="mbwidth"
              src="assets/images/commercial-congrats.svg"
              width="80%"
            />
          </p>
          <div class="mobileview">
            <h2 class="mt-3 consubhead semibld font20 mb-2">
              Thank you for your inquiry!
            </h2>
            <p class="contxt">
              Thank you for trusting Honest Gorilla to help you shop for energy.
              As your energy advisor, we will use the information you provided
              to find the energy plan that fits your business needs. We will
              work hard to negotiate favorable rates and terms on your behalf so
              you can enjoy peace of mind knowing that one of your biggest
              operating expenses is being properly managed.
            </p>
          </div>
          <h2 class="consubhead semibld font20">Next steps, easy as...</h2>
          <div
            class="col-lg-11 col-md-11 col-sm-11 border brdrads d-flex congpad px-0"
          >
            <div class="col-lg-4 col-md-4 col-sm-4 text-center pl-1 pr-1">
              <span class="countcircle">1</span>
              <div class="col-sm-12 mt-2 mb-2">
                <img src="assets/images/downloadfile.svg" width="100" />
              </div>
              <div
                class="col-sm-12 font15 semibld mb-2 clrpurple congimgheadtxt"
              >
                Download & Sign LOA<br />
                <font
                  class="font13 congimgsubheadtxt linktxt"
                  (click)="downloadPdf()"
                  >(See attachment)</font
                >
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 text-center pl-1 pr-1">
              <span class="countcircle">2</span>
              <div class="col-sm-12 p-0 mt-2 mb-2">
                <img src="assets/images/recentbill.svg" width="100" />
              </div>
              <div
                class="col-sm-12 font15 semibld mb-2 clrpurple congimgheadtxt"
              >
                Provide 2 Recent Bill Copies
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 text-center pl-1 pr-1">
              <span class="countcircle">3</span>
              <div class="col-sm-12 p-0 mt-2 mb-2">
                <img src="assets/images/upload.svg" width="100" />
              </div>
              <div
                class="col-sm-12 font15 semibld mb-2 clrpurple congimgheadtxt"
              >
                Submit Your Documentation<br />
                <font class="font13 congimgsubheadtxt"
                  >(LOA & 2 Bill Copies)</font
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6 float-right">
          <div class="pt-4">
            <div class="webview">
              <h2 class="mt-3 consubhead semibld font20 mb-2">
                Thank you for your inquiry!
              </h2>
              <p class="contxt">
                Thank you for trusting Honest Gorilla to help you shop for
                energy. As your energy advisor, we will use the information you
                provided to find the energy plan that fits your business needs.
                We will work hard to negotiate favorable rates and terms on your
                behalf so you can enjoy peace of mind knowing that one of your
                biggest operating expenses is being properly managed.
              </p>
            </div>
            <h2 class="mt-4 consubhead semibld mrgfour font20 mb-2">
              Sign and submit
            </h2>
            <p class="contxt">
              All engagements begin after we have received and processed all
              documentation (signed LOA and 2 recent bill copies).<br />
              <br />
              Please allow up to 5 business days to contact our network of
              energy providers, after which one of our specialists will be in
              touch to present to you our recommendations.
            </p>
            <div class="col-lg-10 col-md-12 m-auto engylogo d-flex">
              <div class="border p-3 float-left mb-4 brdrads">
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Hours: </font>
                  <font class="font16 lnhgt19 oneSpaces">M-F 9am to 6pm</font>
                </p>
                <!-- <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Phone: </font>
                  <font class="font16 lnhgt19 oneSpaces">214-123-1234</font>
                </p> -->
                <p class="text-left mb-1 lneHgt">
                  <font class="font16 lnhgt19 semibld oneSpaces">Email: </font>
                  <font class="font16 lnhgt19 oneSpaces"
                    >sales@honestgorilla.com</font
                  >
                </p>
              </div>
            </div>
            <h2
              class="mt-3 consubhead semibld mrgfour font20 mb-2"
              style="float: left"
            >
              Did you know
            </h2>
            <p class="contxt" style="float: left">
              You can also shop Honest Gorilla to find competitively priced
              energy service at home. Feel free to spread the love to your
              colleagues and employees, we promise to deliver the same value and
              quality experience.<br />
              <a href="/" class="linkclr">Click to learn more</a>
            </p>
          </div>
          <div class="col-sm-12 p-0 pt-1 d-inline-block">
            <p class="font16 consoc">
              Now there’s nothing left to do but share your amazing results with
              your friends:
            </p>
            <div class="congmoblinks">
              <a
                href="http://www.facebook.com/sharer.php?u={{ url }}"
                target="_blank"
                title="Facebook"
                class="card p-1 boxcolour m-1 sgoptpad text-center"
              >
                <span class="faceicon">
                  <a
                    href="http://www.facebook.com/sharer.php?u={{ url }}"
                    target="_blank"
                  >
                    <img src="assets/images/congfb.svg" width="20" />
                  </a>
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre"
                  >Facebook</span
                >
              </a>
              <a
                title="Instagram"
                target="_blank"
                href="https://www.instagram.com/honestgorilla_energy/ "
                class="card p-1 boxcolour m-1 sgoptpad text-center"
              >
                <span class="faceicon">
                  <img src="assets/images/conginstagram.svg" width="20" />
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre"
                  >Instagram</span
                >
              </a>
              <a
                title="Twitter"
                target="_blank"
                href="https://twitter.com/share?url={{
                  url
                }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                class="card p-1 boxcolour m-1 sgoptpad text-center"
              >
                <span class="faceicon">
                  <a
                    href="https://twitter.com/share?url={{
                      url
                    }}&amp;text=I%20just%20signed%20up%20for%20energy%20using%20Honest%20Gorilla%20and%20they’re%20giving%20back%20a%20portion%20of%20my%20usage!&amp;hashtags=lightofunity,light4light,electricity"
                    target="_blank"
                  >
                    <img src="assets/images/congtwitter.svg" width="25" />
                  </a>
                </span>
                <span
                  class="fntwgtvle sgopt ml-1 webview font16 font-weight-bold-calibre"
                  >Twitter</span
                >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid mt-2 pt-3 pb-5" style="background: #f7f7f7">
    <div class="sectpad container section">
      <div class="row">
        <div class="col-sm-6 subsect pb-0 pl-3 pr-3 text-left">
          <h2 class="font23 congmaketxt">
            Make a Difference. <br class="break" />Light the World.
          </h2>
          <p class="desc contxt">
            Since energy is a commodity, we feel we have a duty to help people,
            in whatever capacity we can, to illuminate this world.
          </p>
          <p class="desc contxt">
            Were it not for your support we would not be able to do what we do.
            That is why we set aside a portion of our profits each year to Light
            of Unity, so we are all in alignment to help make this world a
            better, brighter place.
          </p>
        </div>
        <div class="col-sm-6 align-self-center m-auto congpowimg">
          <img src="assets/images/powerful.svg" width="70%" />
        </div>
        <div class="text-center w-100 mt-3">
          <button
            class="btn congrateBtn pl-3 pr-3 pt-1 pb-1 font16 text-uppercase mbnxt"
            (click)="next()"
          >
            LETS GIVEBACK
          </button>
        </div>
      </div>
    </div>
  </div>
</main>

<!--PDF template-->
<div
  id="contentToConvert1"
  style="
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 800px;
    padding: 10px;
    position: fixed;
    z-index: -1;
    margin-top: 15px;
  "
>
  <!-- <header id="header">
      Test Head
    </header> -->

  <div class="text m-auto p-5" style="padding: 80px">
    <table
      width="100%"
      class="pdfform"
      cellpadding="5px"
      cellspacing="5px"
      style="
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        border-collapse: collapse;
        font-size: 10px;
        line-height: 1.5;
        color: #212529;
        font-family: Times New Roman;
        cell-padding: 10px;
      "
    >
      <thead
        align="center"
        style="padding: 10px; font-weight: bold; font-size: 22px"
      >
        <h2
          style="
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            margin-bottom: 0.5rem;
            line-height: 1.2;
            color: inherit;
            word-spacing: 0px;
          "
        >
          LETTER OF AUTHORIZATION (LOA) FOR THE REQUEST OF HISTORICAL USAGE
          INFORMATION
        </h2>
      </thead>
      <tr>
        <td class="header" style="padding: 10px">
          <div
            class="col-12 p-0 row"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0;
              display: flex;
            "
          >
            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <div
                class="input-group m-0 pb-2 pl-5"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  margin: 0;
                  padding-bottom: 0.5rem;
                  display: inline-flex;
                  flex-wrap: wrap;
                "
              >
                <label
                  for="exampleInputEmail1"
                  class="pt-2"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    padding-top: 0.5rem;
                    margin-bottom: 0px;
                    margin-right: 5px;
                    font-weight: bold;
                  "
                  >Date:</label
                >
                <span
                  style="
                    width: 50%;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    border-bottom: 1px solid #000 !important;
                    background-color: #fff;
                    padding: 5px 5px 0px 0;
                    color: #212529;
                    text-align: left;
                    line-height: 17px;
                  "
                  >{{ headerDate }}</span
                >
              </div>
            </div>
            <div
              class="col-6 pl-5"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
                text-align: right;
              "
            >
              <div
                class="input-group m-0 pb-2"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  margin: 0;
                  padding-bottom: 0.5rem;
                  display: inline-flex;
                  flex-wrap: wrap;
                "
              >
                <label
                  for="exampleInputEmail1"
                  class="pt-2"
                  style="
                    padding-top: 0.5rem;
                    font-weight: bold;
                    margin-bottom: 0px;
                    margin-right: 5px;
                  "
                  >Expiration Date:</label
                >
                <span
                  style="
                    width: 50%;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    border-bottom: 1px solid #000 !important;
                    background-color: #fff;
                    padding: 5px 5px 0px 0;
                    color: #212529;
                    text-align: left;
                    line-height: 17px;
                  "
                  >No Expiration / Unlimited</span
                >
              </div>
            </div>
          </div>
          <hr
            width="100%"
            class="bdrline mb-0 pb-0"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              background-color: #000;
              height: 6px;
              border-top: 1px solid rgba(0, 0, 0, 0.1);
            "
          />
        </td>
      </tr>
      <tr>
        <td class="content" style="padding: 0px 10px 10px 10px">
          <div
            class="col-12"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
            "
          >
            <h5
              class="text-left mb-1"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                text-align: left;
                margin-bottom: 0.25rem;
                margin-top: 0;
              "
            >
              <strong style="font-weight: bold; font-size: 10px"
                >SECTION 1. List of Transmission Distribution Utilities
                (TDU)</strong
              >
            </h5>
            <p
              class="text-left"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin-top: 0;
                margin-bottom: 1rem;
              "
            >
              Select all TDUs that apply to this request
            </p>
          </div>
          <div
            class="col-sm-12 row flex-wrap pl-5"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
              display: flex;
              flex-wrap: wrap;
            "
          >
            <table style="width: 100%">
              <tr *ngFor="let utility of utilities; let i = index">
                <!-- <div class="col-sm-12" style="width:100%;" *ngIf="i % 3 == 0"> -->
                <td width="33.3%" *ngIf="i < utilities.length && i % 3 == 0">
                  <div class="checkbox">
                    <!-- <label>
                    <input type="checkbox" value=""> Oncor </label> -->
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: sans-serif;
                        text-align: center;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="utilities[i].underLOA"
                      >X</label
                    >
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: 'Times New Roman', Times, serif;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="!utilities[i].underLOA"
                    ></label>
                    <span>{{ utilities[i].utility }}</span>
                  </div>
                </td>
                <td
                  width="33.3%"
                  *ngIf="i + 1 < utilities.length && i % 3 == 0"
                >
                  <div class="checkbox">
                    <!-- <label>
                    <input type="checkbox" value=""> Oncor </label> -->
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: sans-serif;
                        text-align: center;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="utilities[i + 1].underLOA"
                      >X</label
                    >
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: 'Times New Roman', Times, serif;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="!utilities[i + 1].underLOA"
                    ></label>
                    <span>{{ utilities[i + 1].utility }}</span>
                  </div>
                </td>
                <td
                  width="33.3%"
                  *ngIf="i + 2 < utilities.length && i % 3 == 0"
                >
                  <div class="checkbox">
                    <!-- <label>
                    <input type="checkbox" value=""> Oncor </label> -->
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: sans-serif;
                        text-align: center;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="utilities[i + 2].underLOA"
                      >X</label
                    >
                    <label
                      style="
                        background-color: #c0c0c0;
                        width: 15px;
                        height: 15px;
                        display: inline-block;
                        font-family: 'Times New Roman', Times, serif;
                        margin-bottom: -4px;
                        margin-right: 4px;
                      "
                      *ngIf="!utilities[i + 2].underLOA"
                    ></label>
                    <span>{{ utilities[i + 2].utility }}</span>
                  </div>
                </td>
                <!-- </div> -->
                <!-- <td width="33.3%" class="text-left">
                <div class="checkbox float-left"> -->
                <!-- <label>
                    <input type="checkbox" value=""> CenterPoint </label> -->
                <!-- <label style="background-color: #c0c0c0;width:15px;height: 15px;display: inline-block;font-family:'Times New Roman', Times, serif;
                    margin-bottom: -4px;
                    margin-right: 4px;"></label>
                    <span>CenterPoint</span>
                </div>
              </td> -->
                <!-- <td width="33.3%" class="text-left">
                <div class="checkbox float-left"> -->
                <!-- <label>
                    <input type="checkbox" value=""> Sharyland </label> -->
                <!-- <label style="background-color: #c0c0c0;width:15px;height: 15px;display: inline-block;font-family:'Times New Roman', Times, serif;
                   margin-bottom: -4px;
                    margin-right: 4px;"></label>
                    <span>Sharyland</span>
                </div>
              </td> -->
              </tr>
              <!-- <tr>
              <td width="33.3%">
                <div class="checkbox">
                  <!-- <label>
                    <input type="checkbox" value=""> AEP </label> -->
              <!-- <label style="background-color: #c0c0c0;width:15px;height: 15px;display: inline-block;font-family:'Times New Roman', Times, serif;
                   margin-bottom: -4px;
                    margin-right: 4px;"></label>
                    <span>AEP</span>
                </div>
              </td>
              <td width="33.3%" class="text-left">
                <div class="checkbox float-left"> -->
              <!-- <label>
                    <input type="checkbox" value=""> TNMP </label> -->
              <!-- <label style="background-color: #c0c0c0;width:15px;height: 15px;display: inline-block;font-family:'Times New Roman', Times, serif;
                    margin-bottom: -4px;
                    margin-right: 4px;"></label>
                    <span>TNMP</span>
                </div>
              </td>
              <td width="33.3%">&nbsp;</td>
              
            </tr>  -->
            </table>
          </div>
          <hr
            width="100%"
            class="bdrline"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              background-color: #000;
              padding: 0 15px;
              height: 6px;
              margin: 1rem 0;
              border-top: 1px solid rgba(0, 0, 0, 0.1);
            "
          />
          <div
            class="col-12 text-left"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
            "
          >
            <h5
              class="text-left mb-1"
              style="
                display: inline-block;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                text-align: left;
                margin-bottom: 0.25rem;
                margin-top: 0;
                font-size: 10px;
              "
            >
              SECTION 2.
            </h5>
            <span style="font-size: 10px">
              Please accept this letter as a formal request and authorization
              for the above referenced TDU to release energy usage data,
              including kWh, kVA or KW and interval data (if applicable) at the
              following location(s) to Honest Gorilla, my designated agent. This
              information request shall be limited to the most recent 12-month
              period of service. If the ESI ID are IDR account(s), please
              indicate whether summary level or and/or interval data is
              required.
            </span>
          </div>
          <div
            class="col-12"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
            "
          >
            <!-- <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem">
</p> -->
            <div
              class="col-sm-12 row flex-wrap"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 100%;
                flex: 0 0 100%;
                max-width: 100%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding: 0 15px;
                display: flex;
                flex-wrap: wrap;
                margin: 10px 0px;
              "
            >
              <div
                class="col-4 text-center"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: center;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 33.333333%;
                  flex: 0 0 33.333333%;
                  max-width: 33.333333%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding-right: 15px;
                  padding-left: 15px;
                  margin: 5px 0px;
                "
              >
                <div class="checkbox">
                  <!-- <label>
                    <input type="checkbox" value=""> Summary Billing Data Only  
                     </label> -->
                  <label
                    style="
                      background-color: #c0c0c0;
                      width: 15px;
                      height: 15px;
                      display: inline-block;
                      font-family: sans-serif;
                      text-align: center;
                      margin-bottom: -4px;
                      margin-right: 4px;
                    "
                  ></label>
                  <span>Summary Billing Data Only</span>
                </div>
              </div>
              <div
                class="col-4 text-center"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: center;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 33.333333%;
                  flex: 0 0 33.333333%;
                  max-width: 33.333333%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding-right: 15px;
                  padding-left: 15px;
                  margin: 5px 0px;
                "
              >
                <div class="checkbox">
                  <!-- <label>
                    <input type="checkbox" value=""> Interval Data Only </label> -->
                  <label
                    style="
                      background-color: #c0c0c0;
                      width: 15px;
                      height: 15px;
                      display: inline-block;
                      font-family: sans-serif;
                      text-align: center;
                      margin-bottom: -4px;
                      margin-right: 4px;
                    "
                  ></label>
                  <span>Interval Data Only</span>
                </div>
              </div>
              <div
                class="col-4 text-center"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: center;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 33.333333%;
                  flex: 0 0 33.333333%;
                  max-width: 33.333333%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding-right: 15px;
                  padding-left: 15px;
                  margin: 5px 0px;
                "
              >
                <div class="checkbox">
                  <!-- <label>
                    <input type="checkbox" value=""> Both Summary and Interval Data </label> -->
                  <label
                    style="
                      background-color: #c0c0c0;
                      width: 15px;
                      height: 15px;
                      display: inline-block;
                      font-family: sans-serif;
                      text-align: center;
                      margin-bottom: -4px;
                      margin-right: 4px;
                    "
                    >X</label
                  >
                  <span>Both Summary and Interval Data</span>
                </div>
              </div>
            </div>

            <p
              class="mb-3 text-left"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin-bottom: 1rem;
              "
            >
              If an attachment is used, a separate attachment will be used per
              TDU with the electric service identifier number (ESI ID) specific
              to each TDU. The TDU will reject if submitted ESI IDs are not
              associated with their territory.
            </p>
          </div>
          <!--Heading-->
          <div
            class="col-12 row flex-wrap"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
              display: flex;
              flex-wrap: wrap;
            "
          >
            <div
              class="col-7"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                text-align: center;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 58.333333%;
                flex: 0 0 58.333333%;
                max-width: 58.333333%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  margin-bottom: 0.5rem;
                  line-height: 1.2;
                  color: inherit;
                  margin-top: 0;
                  text-align: left;
                "
              >
                <span
                  class="nav-tabs bdrblk"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    border-bottom: 1px solid #000;
                    text-align: left;
                    font-weight: bold;
                    font-size: 10px;
                  "
                  >Service Address</span
                >
              </h5>
            </div>
            <div
              class="col-5"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                text-align: center;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 41.666666%;
                flex: 0 0 41.666666%;
                max-width: 33.333333%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  margin-bottom: 0.5rem;
                  line-height: 1.2;
                  color: inherit;
                  margin-top: 0;
                  text-align: left;
                "
              >
                <span
                  class="nav-tabs bdrblk"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    border-bottom: 1px solid #000;
                    text-align: left;
                    font-weight: bold;
                    font-size: 10px;
                  "
                  >ESI ID (found on bill)</span
                >
              </h5>
            </div>
          </div>

          <!--Address Iteration-->
          <div *ngFor="let addres of address; let i = index">
            <!--ESIID Iteration-->

            <div *ngIf="addres.esiids.length > 0">
              <div
                *ngFor="let esiid of addres.esiids"
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  *ngIf="esiid && esiid.value"
                  class="col-7"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    text-align: center;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 58.333333%;
                    flex: 0 0 58.333333%;
                    max-width: 58.333333%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <p
                    class="mb-3"
                    style="
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      margin-bottom: 1rem;
                      margin-top: 0;
                      text-align: left;
                    "
                  >
                    {{ addres.address }}
                  </p>
                  <!-- <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 538 Dallas, TX 75204</p>
                    <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 536 Dallas, TX 75204</p>
                    <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 534 Dallas, TX 75204</p> -->
                </div>
                <div
                  *ngIf="esiid && esiid.value"
                  class="col-5"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    text-align: center;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 41.666666%;
                    flex: 0 0 41.666666%;
                    max-width: 33.333333%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <p
                    class="mb-3"
                    style="
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      margin-bottom: 1rem;
                      margin-top: 0;
                      text-align: left;
                    "
                  >
                    {{ esiid.value }}
                  </p>
                  <!-- <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">10443720002296655</p>
                    <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">10443720002296677</p>
                    <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">10443720002296688</p> -->
                </div>
              </div>
            </div>

            <div *ngIf="addres.esiids.length === 0">
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-7"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    text-align: center;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 58.333333%;
                    flex: 0 0 58.333333%;
                    max-width: 58.333333%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <div style="padding: 10px 0 5px 0 !important">
                    <p
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        text-align: left;
                        margin-bottom: 3px !important;
                      "
                    >
                      {{ addres.address }}
                    </p>
                  </div>
                  <!-- <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 538 Dallas, TX 75204</p>
                      <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 536 Dallas, TX 75204</p>
                      <p class="mb-3" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-bottom:1rem;margin-top: 0;text-align: left">3110 Thomas Ave APT 534 Dallas, TX 75204</p> -->
                </div>
                <div
                  class="col-5"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    text-align: center;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 41.666666%;
                    flex: 0 0 41.666666%;
                    max-width: 33.333333%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <div
                    style="
                      border-bottom: 1px solid #5f5f5f !important;
                      min-height: 20px !important;
                      margin-top: 1px !important;
                      margin-bottom: 3px !important;
                    "
                  >
                    <p
                      class="mb-3"
                      style="
                        -webkit-box-sizing: border-box;
                        color: #000 !important;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        text-align: left;
                        margin-bottom: 3px !important;
                      "
                    >
                      {{ addres.esiid }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                addres.esiids.length == 0 &&
                addres.address.length < 0 &&
                i == address.length - 1
              "
            >
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
              </div>
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
              </div>
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
              </div>
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
              </div>
              <div
                class="col-12 row flex-wrap"
                style="
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  -webkit-box-flex: 0;
                  -ms-flex: 0 0 100%;
                  flex: 0 0 100%;
                  max-width: 100%;
                  position: relative;
                  width: 100%;
                  min-height: 1px;
                  padding: 0 15px;
                  display: flex;
                  flex-wrap: wrap;
                "
              >
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
                <div
                  class="col-6"
                  style="
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 0;
                    -ms-flex: 0 0 50%;
                    flex: 0 0 50%;
                    max-width: 50%;
                    position: relative;
                    width: 100%;
                    min-height: 1px;
                    padding-right: 15px;
                    padding-left: 15px;
                  "
                >
                  <h5
                    style="
                      width: 100%;
                      -webkit-box-sizing: border-box;
                      -moz-box-sizing: border-box;
                      box-sizing: border-box;
                      text-align: left;
                      margin-bottom: 0.25rem;
                      margin-top: 0;
                    "
                  >
                    <span
                      class="nav-tabs bdrblk"
                      style="
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                        border-bottom: 1px solid #000;
                        width: 100%;
                        display: block;
                      "
                      >&nbsp;</span
                    >
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <hr
            width="100%"
            class="bdrblk mb-2 mt-3"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              margin-top: 1rem;
              margin-bottom: 0.5rem;
              border-color: #000;
            "
          />
          <div
            class="col-12"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
            "
          >
            <p
              class="mb-2 text-left"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin-top: 0;
                margin-bottom: 0.5rem;
              "
            >
              Please forward usage and load information in electronic (Microsoft
              Excel) format to:
            </p>
            <div
              class="input-group m-0"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin: 0;
                display: flex;
                flex-wrap: wrap;
              "
            >
              <label class="pr-2">
                <strong style="font-family: 'Calibre-SemiBold'">E-mail:</strong>
              </label>
              <span>
                <a href="javascript:void(0)" style="color: blue"
                  >sales@honestgorilla.com</a
                >
              </span>
            </div>
          </div>
          <hr
            width="100%"
            class="bdrline"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              background-color: #000;
              height: 6px;
              padding: 0 15px;
              margin: 1rem 0;
              border-top: 1px solid rgba(0, 0, 0, 0.1);
            "
          />
          <div
            class="col-12"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
            "
          >
            <h5
              class="text-left mb-2"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                text-align: left;
                margin-bottom: 0.25rem;
                margin-top: 0;
                font-weight: bold;
                font-size: 10px;
              "
            >
              SECTION 3. AUTHORIZATION
            </h5>
            <p
              class="text-left"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin-top: 0;
                margin-bottom: 1rem;
              "
            >
              By affixing my signature below, I affirm that I have the authority
              to make and sign this request on behalf of my company for all ESI
              IDs associated with this request.
            </p>
            <p
              class="text-left"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                margin-top: 0;
                margin-bottom: 1rem;
              "
            >
              <!-- <span style="background-color:#c0c0c0;padding: 5px;display: inline-block; border: 1px solid #999999;font-size:100%;">x</span> -->
              <label
                style="
                  background-color: #c0c0c0;
                  width: 15px;
                  height: 15px;
                  display: inline-block;
                  font-family: sans-serif;
                  text-align: center;
                "
                >X</label
              >

              By checking this box, the Customer identified below and
              (Requesting Party) Honest Gorilla affirm that the authorizing
              signature is the Customer identified below and hold the TDU
              harmless for providing historical data to requested party as
              identified on this form.
            </p>
          </div>
          <div
            class="col-12 row flex-wrap"
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              -webkit-box-flex: 0;
              -ms-flex: 0 0 100%;
              flex: 0 0 100%;
              max-width: 100%;
              position: relative;
              width: 100%;
              min-height: 1px;
              padding: 0 15px;
              display: flex;
              flex-wrap: wrap;
            "
          >
            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk"
                  style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000; width:100%;display: block;">&nbsp;</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Signature</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  &nbsp;
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Signature</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 10px">
                <span class="nav-tabs bdrblk" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000; width:100%; display:block;
font-family: Times New Roman;font-size:12px;">{{buisnessName ? buisnessName : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Company</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ buisnessName ? buisnessName : '' }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Company</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk"
                  style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000;width:100%; display:block;
font-family: Times New Roman;font-size:12px;">{{ contactInfo ? (contactInfo.firstName +' '+ contactInfo.lastName) : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Name, printed</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{
                    contactInfo
                      ? contactInfo.firstName + ' ' + contactInfo.lastName
                      : ''
                  }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Name, printed</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000; width:100%; display:block;
font-family: Times New Roman;font-size:12px;">{{contactInfo ? contactInfo.billingAddress : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Billing Street Address</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ contactInfo ? contactInfo.billingAddress : '' }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Billing Street Address</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk"
                  style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000; width:100%; display:block;font-family: Times New Roman;font-size:12px;">
                  {{contactInfo ? contactInfo.title : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Title</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ contactInfo ? contactInfo.title : '' }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Title</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000;width:100%; display:block;
font-family: Times New Roman;font-size:12px;">{{city +','+ state +','+ zipCode}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                City, State, Zip Code</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ city + ',' + state + ',' + zipCode }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>City, State, Zip Code</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk"
                  style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000; width:100%; display:block; font-family: Times New Roman;font-size:12px;">
                  {{contactInfo ? contactInfo.email : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Email Address</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ contactInfo ? contactInfo.email : '' }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Email Address</p>
            </div>

            <!-- <div class="col-6" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;-webkit-box-flex: 0;-ms-flex: 0 0 50%;flex: 0 0 50%;max-width: 50%;position: relative;
    width: 100%;min-height: 1px;padding-right: 15px;padding-left: 15px;">
              <h5
                style="width:100%; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: left;margin-bottom: .25rem;margin-top: 0">
                <span class="nav-tabs bdrblk"
                  style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;border-bottom: 1px solid #000;width:100%; display:block;font-family: Times New Roman;font-size:12px;">
                  {{contactInfo ? contactInfo.phone : ''}}</span>
              </h5>
              <p class="mb-3"
                style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">
                Telephone Number</p>
            </div> -->

            <div
              class="col-6"
              style="
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
                -webkit-box-flex: 0;
                -ms-flex: 0 0 50%;
                flex: 0 0 50%;
                max-width: 50%;
                position: relative;
                width: 100%;
                min-height: 1px;
                padding-right: 15px;
                padding-left: 15px;
              "
            >
              <h5
                style="
                  width: 100%;
                  -webkit-box-sizing: border-box;
                  -moz-box-sizing: border-box;
                  box-sizing: border-box;
                  text-align: left;
                  margin-top: 0;
                "
              >
                <span
                  class=""
                  style="
                    width: 100%;
                    display: block;
                    font-family: Times New Roman;
                    font-size: 12px;
                  "
                >
                  {{ contactInfo ? contactInfo.phone : '' }}
                </span>
              </h5>
              <div
                style="
                  border: 1px solid #5f5f5f !important;
                  min-height: 2px !important;
                  margin-top: 1px !important;
                  margin-bottom: 3px !important;
                "
              ></div>
              <p>Telephone Number</p>
            </div>
          </div>
        </td>
      </tr>
      <!-- <tr>
      <td align="right" class="text-right footer" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;
      padding:10px; text-align: right">
        <hr class="bdrline" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;background-color: #000; height: 6px;margin: 1rem 0;border-top: 1px solid rgba(0,0,0,.1)"
        />
        <div class="float-right text-center" style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;text-align: center;float: right">
          <img src="https://d3tftv5yijcm18.cloudfront.net/38549:12292:1020?fileName=logotxt.png" style="width:176px;height: 33px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;vertical-align: middle;
    border-style: none;" />
          <p style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">v_04201915</p>

        </div>
      </td>
    </tr> -->
      <tfoot
        align="right"
        class="text-right"
        style="
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          padding: 10px;
          text-align: right;
        "
      >
        <!-- <img class="crazyFrog" />
      <img id="logoImg" src="https://d3tftv5yijcm18.cloudfront.net/38549:12292:1020?fileName=logotxt.png" style="width:176px;height: 33px; -webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;vertical-align: middle;
      border-style: none;" /> -->
        <!-- <p style="-webkit-box-sizing: border-box;-moz-box-sizing: border-box; box-sizing: border-box;margin-top: 0;margin-bottom: 1rem;">v_04201915</p> -->
        <hr
          width="100%"
          class="bdrline"
          style="
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            background-color: #000;
            height: 6px;
            padding: 0 15px;
            margin: 1rem 0;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
          "
        />
        <div
          class="float-right text-center"
          style="
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            text-align: center;
            float: right;
          "
        >
          <img
            src="
        data:image/png;base64,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
        "
            style="
              height: 33px;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              vertical-align: middle;
              border-style: none;
              margin-right: 30px;
            "
          />
          <p
            style="
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              margin-top: 0;
              margin-bottom: 1rem;
            "
          >
            v_{{ footerDate }}
          </p>
        </div>
      </tfoot>
    </table>
  </div>
  <!-- <footer>
    Test Footer
  </footer> -->
</div>

<!-- Modal -->
<div class="backdrop" [ngStyle]="{ display: display }"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{ display: display }">
  <div class="modal-dialog" role="document">
    <div class="modal-content m-auto blockbg boxclr text-center">
      <div class="modal-body">
        <!-- <div class="mt-5"> -->
        <div class="">
          <img src="assets/images/loading.gif" />
          <p class="text-center tipmes font15">
            Please wait for a few seconds...
          </p>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal !-->
